const useShippingRegions = () => {
  const regions = [
    {
      label: 'Raleigh-Durham, NC',
    },
    {
      label: 'Fayetteville, NC',
    },
    {
      label: 'Orlando, FL',
    },
  ];
  return regions;
};

export default useShippingRegions;
